module.exports = __webpack_public_path__ + "3b0057e62e00cca46883c706d03d98f0.png";